export enum DISPLAY_STATE {
  LOCK,
  UNLOCK,
  QA,
  FULL,
  CONFIRM
}
